export default function responseToJson(response) {
  let json = {};
  try {
    json = response.json();
  } catch (error) {
    throw (error);
  }
  return json;
}
